import styled from 'styled-components'

export const AddressContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #f8f8f8;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 0.5rem 0.8rem;
    margin-bottom: 15px;

    p {
        margin: 0.15rem 0;
    }
`;
